import { render, staticRenderFns } from "./field-information.vue?vue&type=template&id=9f64e98a&scoped=true"
import script from "./field-information.vue?vue&type=script&lang=js"
export * from "./field-information.vue?vue&type=script&lang=js"
import style0 from "./field-information.vue?vue&type=style&index=0&id=9f64e98a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f64e98a",
  null
  
)

export default component.exports